import React, { useState } from 'react'
import { Popover, PopoverBody } from 'reactstrap'
import { BsThreeDots } from 'react-icons/bs'
import { BiFolder } from 'react-icons/bi'
import { formatItemCount } from './folderService'

// A folder rendered as a card in the Library mobile list — matches the Library
// survey card (white, rounded 12px, 3-dots top-right). Tapping the content opens
// the folder; admins get an Open / Rename / Delete menu. Library-only (the Lines
// screens use FolderRowMobileLines instead).
const FolderRowMobile = ({
  folder,
  itemCount,
  itemNoun,
  isAdmin,
  onOpen,
  onRename,
  onDelete,
}) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const popoverId = `folderCardMobile_${folder._id}`

  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '14px 16px',
        position: 'relative',
      }}>
      {isAdmin && (
        <div style={{ position: 'absolute', top: '12px', right: '12px' }}>
          <span
            id={popoverId}
            className="cursor-pointer"
            onClick={() => setMenuOpen(true)}>
            <BsThreeDots />
          </span>
          <Popover
            isOpen={menuOpen}
            target={popoverId}
            toggle={() => setMenuOpen(false)}
            placement="bottom"
            modifiers={{
              flip: { boundariesElement: 'viewport' },
              preventOverflow: { boundariesElement: 'viewport' },
            }}
            hideArrow
            className="surveyListRow_Popover">
            <PopoverBody>
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  setMenuOpen(false)
                  if (onOpen) {
                    onOpen()
                  }
                }}>
                Open folder
              </div>
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  setMenuOpen(false)
                  if (onRename) {
                    onRename(folder)
                  }
                }}>
                Rename folder
              </div>
              <div
                className="dropdown-item my-1 cursor-pointer folder-menu-item-delete"
                onClick={() => {
                  setMenuOpen(false)
                  if (onDelete) {
                    onDelete(folder)
                  }
                }}>
                Delete folder
              </div>
            </PopoverBody>
          </Popover>
        </div>
      )}

      <div
        className="cursor-pointer folder-card-mobile-content"
        onClick={() => {
          if (onOpen) {
            onOpen()
          }
        }}>
        <div className="folder-row-icon-wrap">
          <BiFolder className="folder-row-icon" />
        </div>
        <div className="folder-card-mobile-text">
          <span
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1a1a1a',
              margin: '0 0 4px 0',
              paddingRight: '28px',
              lineHeight: '1.4',
              wordBreak: 'break-word',
            }}>
            {folder.name}
          </span>
          <p
            style={{
              fontSize: '14px',
              color: '#6b7280',
              margin: '2px 0 6px 0',
            }}>
            {formatItemCount(itemCount, itemNoun)}
          </p>
        </div>
      </div>
    </div>
  )
}

export default FolderRowMobile
